export function getSecuredAssetsUrl(): string {
  return import.meta.env.VITE_SECURED_ASSETS_URL;
}
